import { eventListenerOrTimeout } from '../../events/event-listener-or-timeout';
import { getTransitionEndEventName } from '../get-transition-end-event-name';

const transitionEndEventName = getTransitionEndEventName();

export function addTransitionEndListener(
	element: Element,
	callback: () => void,
	fallbackDuration = 0,
	remove = true
): void {
	eventListenerOrTimeout(
		transitionEndEventName,
		element,
		callback,
		fallbackDuration,
		remove
	);
}
